import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, ResolveEnd, Router, Scroll} from '@angular/router';
import {Subscription} from 'rxjs';
import {EbAnalyticsService} from 'src/app/features/analytics/services/facades/eb-analytics.service';

@Component({
    selector: 'eb-matomo',
    templateUrl: './eb-matomo.component.html',
    styleUrls: ['./eb-matomo.component.scss'],
    standalone: false
})
export class EbMatomoComponent implements OnInit, OnDestroy {

  urlSubscription: Subscription

  constructor(
    private router: Router,
    private ebAnalyticsService: EbAnalyticsService
    ) {}

  setUrlForAnalytics() {
    this.urlSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.ebAnalyticsService.lastNavigationEndUrl = event.urlAfterRedirects
        if(this.ebAnalyticsService.lastResolveEndUrl !== this.ebAnalyticsService.lastNavigationEndUrl){
          this.ebAnalyticsService.pushCustomUrl(event.urlAfterRedirects)
        }
      } else if(event instanceof ResolveEnd){
        this.ebAnalyticsService.lastResolveEndUrl = event.urlAfterRedirects
        if(this.ebAnalyticsService.lastResolveEndUrl !== this.ebAnalyticsService.lastNavigationEndUrl && this.ebAnalyticsService.lastResolveEndUrl !== this.ebAnalyticsService.lastScrollUrl){
          this.ebAnalyticsService.pushCustomUrl(event.urlAfterRedirects)
        }
      } else if((event instanceof Scroll && event.routerEvent instanceof NavigationEnd)){
          this.ebAnalyticsService.lastScrollUrl = event.routerEvent.urlAfterRedirects
          if(this.ebAnalyticsService.lastScrollUrl !== this.ebAnalyticsService.lastNavigationEndUrl && this.ebAnalyticsService.lastScrollUrl !== this.ebAnalyticsService.lastResolveEndUrl){
            this.ebAnalyticsService.pushCustomUrl(event.routerEvent.urlAfterRedirects)
        }
      }
    })
  }

  ngOnInit(): void {
    this.setUrlForAnalytics()
  }

  ngOnDestroy(): void {
    this.urlSubscription.unsubscribe()
  }
}
